<template>
  <div id="water-hazard-getting-started">
    <the-top-bar showUser />

    <div class="row">
      <info-cards :data-info-cards="infoCardsData" />
    </div>
  </div>
</template>
<script>
import TheTopBar from '@/components/TheTopBar'
import InfoCards from '@/components/TheSurveysGettingStartedInformation'
import { mapState } from 'vuex'
export default {
  name: 'WaterHazardGettingStarted',
  components: {
    TheTopBar,
    InfoCards
  },
  props: {},
  data() {
    return {
      infoCardsData: [
        {
          title: "Water Shortage Hazard",
          description:
            "Use the Household Water Demand Calculator provided to estimate the amount of water your household would use over a 2-week period to meet all household demands and essential household needs (flushing toilets, showering, personal hygiene, cleaning surfaces, cooking).",
          buttonText: "Next",
          cardClass: "",
          wrapperClass: "col s12",
          route: "",
        },
        {
          title: "Lets Get Started",
          description:
            "In the next step, you will compare this demand against your available onsite water storage tank capacity and, using the definitions provided in the Expected Impact Level Chart, determine the expected level of impact to your household during a 2-week period without WASCO supply.",
          buttonText: "Click To Begin",
          cardClass: "",
          wrapperClass: "col s12",
          route: "WaterHazardSurvey",
        },
      ],
    };
  },
  created() {
  //  if (this.surveyStarted) this.$router.push({ name: "WaterHazardSurvey" });
  },
  mounted() {
    // this.$router.push({ name: "WindHazardSurvey" });
  },
  computed: {
    ...mapState({
      surveyStarted: (state) => state.Surveys.waterHazardStarted,
    }),
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
#water-hazard-getting-started {
}
</style>
